import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface DateRangeInputsProps {
  from: string | undefined;
  to: string | undefined;
  onChange: (patch: {
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
  }) => void;
}

function normalize(raw: string): string | undefined {
  return raw.length > 0 ? raw : undefined;
}

export function DateRangeInputs({ from, to, onChange }: DateRangeInputsProps) {
  return (
    <div className="w-full space-y-1.5 md:w-auto">
      <span className="block text-xs font-medium text-muted-foreground">
        Ricevuta
      </span>
      <div className="flex items-end gap-2">
        <div className="flex flex-1 flex-col gap-1 md:flex-none">
          <Label htmlFor="dateFrom" className="text-[11px] text-muted-foreground">
            Da
          </Label>
          <Input
            id="dateFrom"
            type="date"
            className="h-9 w-full md:w-[160px]"
            value={from ?? ""}
            onChange={(e) => onChange({ dateFrom: normalize(e.target.value) })}
          />
        </div>
        <div className="flex flex-1 flex-col gap-1 md:flex-none">
          <Label htmlFor="dateTo" className="text-[11px] text-muted-foreground">
            A
          </Label>
          <Input
            id="dateTo"
            type="date"
            className="h-9 w-full md:w-[160px]"
            value={to ?? ""}
            onChange={(e) => onChange({ dateTo: normalize(e.target.value) })}
          />
        </div>
      </div>
    </div>
  );
}
